import { Routes, Route } from "react-router-dom";
import ChefdeporjetLayout from "../layouts/ChefdeporjetLayout";
import DemandeList from "../pages/chefProjet/DemandeList";
import TaskBoardWrapper from "../pages/chefProjet/TaskBoardWrapper";
import TicketDetailCard from "../pages/chefProjet/PageDetail";
import DemandeDetail from "../pages/chefProjet/DemandeDetail";
import Dashboard from "../pages/chefProjet/Dashboard"


const ChefProjetRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<ChefdeporjetLayout />}>
                <Route path="home" element={<TaskBoardWrapper />} />
                <Route
                    path="/task/:id"
                    element={<TicketDetailCard />}
                />
                <Route path="/demande" element={<DemandeList />} />
                <Route path="/demande/:id" element={<DemandeDetail />} />
                <Route path="/Dashboard" element={<Dashboard />} />
            </Route>

        </Routes>
    );
};

export default ChefProjetRoutes;
